export enum LocationsLegacyIds {
  HAYWARD = 1,
  BROOKLYN = 4,
  REDMOND = 6,
  AUSTIN = 7,
  MIAMI = 9,
  QUEEN_CITY = 14,
}
